<template>
  <div class="view view-manager">
    <manager-navbar />
    <router-view></router-view>
  </div>
</template>

<script setup lang="ts">
import ManagerNavbar from "./common/ManagerNavbar.vue";
</script>

<style lang="scss">
.view-manager {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: min-content minmax(0, 1fr);
  height: 100%;
}
</style>
